// src/hooks/hotelRatings/useGetHotelRatings.js
import { useQuery } from "@tanstack/react-query";
import { getAllHotelRatings } from "../../api/apiHotelRatings";

const QUERY_KEY = ["hotelRatings"];

const useGetHotelRatings = (page = 1, perPage = 15, filters = {}) => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [...QUERY_KEY, page, perPage, filters],
    queryFn: () => getAllHotelRatings(page, perPage, filters),
    keepPreviousData: true,
  });

  return {
    isLoading,
    error: isError ? error : null,
    hotelRatings: data?.data || data?.hotelRatings || [],
    meta: data?.data?.meta || null,
  };
};

export default useGetHotelRatings;
